import { IBudgetSummary } from '../../../createAndEdit/types';

interface IDetailSummaryMobileProps {
  summary: IBudgetSummary;
  counterProposalAcceptedAt?: string | null;
}

const DetailSummaryMobile = (props: IDetailSummaryMobileProps) => {
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  return (
    <div className="border border-gray-300 rounded-md p-3">
      <div className="flex flex-col gap-3">
        <div className="flex flex-row items-center justify-between gap-2">
          <span className="text-gray-600">Subtotal:</span>
          <span className="font-bold">{formatCurrency(props.summary.subtotal)}</span>
        </div>
        <div className="flex flex-row items-center justify-between gap-2">
          <span className="text-green-600">Descontos:</span>
          <span className="font-bold text-green-600">{formatCurrency(props.summary.discounts)}</span>
        </div>
        <div className={`flex flex-row items-center justify-between gap-2 ${props.counterProposalAcceptedAt ? 'line-through' : ''}`}>
          <span className="font-bold text-size-14">Valor a ser pago:</span>
          <span className="font-bold text-size-14">{formatCurrency(props.summary.totalToPay)}</span>
        </div>
        {props.counterProposalAcceptedAt && (
          <div className="flex flex-row items-center justify-between gap-2">
            <span className="font-bold text-size-14">Valor a ser pago:</span>
            <span className="font-bold text-size-14">{formatCurrency(props.summary.counterProposalValue || 0)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailSummaryMobile;
